<template>
  <div>
    <el-card class="elshadow w-full rounded-10px">
      <div v-if="!show.isShowHome">
        <!-- <div class="mb-12">
          <div class="mb-8">
            <p class="text-primary mb-1">Action</p>
            <h2 class="text-4f4f4f font-semibold fsize20">Quick Shortcuts</h2>
          </div>

          <div class="grid grid-cols-4 gap-4">
            <div class="text-center">
              <div class="bg-f4f5f6 roundebox-pm mx-auto">
                <img
                  src="@/views/adminPanel/pages/builder/NewScreen/img/pm/ticket.png"
                  alt="image"
                />
              </div>
              <p class="text-center text-4f4f4f pt-2">My Tickets</p>
            </div>

            <div class="text-center">
              <div class="bg-f4f5f6 roundebox-pm mx-auto">
                <img
                  src="@/views/adminPanel/pages/builder/NewScreen/img/pm/projectstatus.png"
                  alt="image"
                />
              </div>
              <p class="text-center text-4f4f4f pt-2">Project Status</p>
            </div>

            <div
              class="text-center cursor-pointer"
              @click="showDetails('isShowNotification')"
            >
              <div class="bg-f4f5f6 roundebox-pm mx-auto">
                <img
                  src="@/views/adminPanel/pages/builder/NewScreen/img/pm/bell.png"
                  alt="image"
                />
              </div>
              <p class="text-center text-4f4f4f pt-2">Notifications</p>
            </div>

            <div class="text-center">
              <div class="bg-f4f5f6 roundebox-pm mx-auto">
                <img
                  src="@/views/adminPanel/pages/builder/NewScreen/img/pm/ticket.png"
                  alt="image"
                />
              </div>
              <p class="text-center text-4f4f4f pt-2">Chat support</p>
            </div>
          </div>
        </div> -->

        <div>
          <iframe
            height="750px"
            width="100%"
            src="https://meet.brained.app/portal-embed#/customer/client-servicing"
            frameborder="0"
            allowfullscreen=""
          ></iframe>
        </div>
      </div>

      <div v-if="show.isShowHome">
        <div class="flex items-center mb-6" @click="showDetails('isShowHome')">
          <feather-icon icon="ArrowLeftIcon" class="text-builderprimary mr-3" />
          Go Back
        </div>

        <Notification />
      </div>
    </el-card>
    <!-- <el-card class="elshadow rounded-10px mt-8">
      <div class="mb-4">
        <p class="text-primary mb-1">Frequently Asked Questions</p>
        <h2 class="text-4f4f4f font-semibold fsize20">
          You got questions, we got answers
        </h2>
      </div>

      <div class="mt-2">
        <vs-collapse>
          <vs-collapse-item class="elcollapse-ct">
            <div slot="header" class="text-4f4f4f fsize14">
              How can i connect with my PM?
            </div>

            <div>
              <p class="fsize14">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
              </p>
            </div>
          </vs-collapse-item>

          <vs-collapse-item class="elcollapse-ct">
            <div slot="header" class="text-4f4f4f fsize14">
              How can i connect with my PM?
            </div>

            <div>
              <p class="fsize14">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
              </p>
            </div>
          </vs-collapse-item>

          <vs-collapse-item class="elcollapse-ct">
            <div slot="header" class="text-4f4f4f fsize14">
              How can i connect with my PM?
            </div>

            <div>
              <p class="fsize14">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
              </p>
            </div>
          </vs-collapse-item>

          <vs-collapse-item class="elcollapse-ct">
            <div slot="header" class="text-4f4f4f fsize14">
              How can i connect with my PM?
            </div>

            <div>
              <p class="fsize14">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                rhoncus eros tortor, non fringilla lectus cursus et. Fusce vel
                nisi ante. Aliquam sit amet lectus pharetra, luctus mi sed,
                aliquet felis. Mauris a tortor viverra, ornare tellus in,
                consectetur leo.
              </p>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </div>
    </el-card> -->
  </div>
</template>

<script>
import Notification from "./Notification";

import Datepicker from "vuejs-datepicker";
import { mapState } from "vuex";
export default {
  data() {
    return {
      title: "",
      message: "",
      isShowNotification: true,
      show: {
        isShowNotification: false,
        isShowStatus: false,
        isShowHome: true,
      },
      additionalDetails: "",
    };
  },
  computed: {
    ...mapState("user", ["selectedProject"]),
  },
  methods: {
    async showDetails(item) {
      await Object.keys(this.show).forEach((element) => {
        console.log(this.show[element]);
        this.show[element] = false;
      });
      this.show[item] = true;
    },

    async sendEmail() {
      if (this.title.trim().length != 0 && this.message.trim().length != 0) {
        let payload = {
          title: this.title,
          message: this.message,
        };
        await this.$store.dispatch("admin/SendEmail", payload);
        this.$swal({
          title: "Your call has been Scheduled",
          text: "Your Virtual Project Manager will connect with you shortly",
          icon: "success",
          confirmButtonColor: "#830c81",
          confirmButtonText: "OK",
        });
      } else {
        this.$swal({
          title: "Please Enter valid Inputs",

          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "OK",
        });
      }
    },
  },
  mounted() {
    this.showDetails();
  },
  components: {
    Datepicker,

    Notification,
  },
};
</script>
